import React from "react";
import CompanyCard from "../../components/sections/front/CompanyCard.js";
import OrganizationCard from "../../components/sections/front/OrganizationCard.js";
import MenuCard from "../../components/sections/front/MenuCard.js";
import FooterCard from "../../components/sections/front/FooterCard.js";

const menuItems = [
  // {
  //   label: "Create Company",
  //   icon: "fa-regular fa-plus",
  //   link: "/manage-company",
  // },

  {
    label: "Jobs",
    icon: "fa-fw fa-solid fa-briefcase",
    link: "/jobs-list",
  },
  {
    label: "Applications",
    icon: "fa-regular fa-newspaper",
    link: "/applications",
  },
  { label: "Saved Jobs", icon: "fa-regular fa-bookmark", link: "/saved-jobs" },
];

const CommonSideBar = () => {
  return (
    <div className="space-y-3">
      <CompanyCard />
      <OrganizationCard />
      <MenuCard items={menuItems} />
      <FooterCard />
    </div>
  );
};

export default CommonSideBar;
